"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeEmbedComponentWebsiteRender = exports.YoutubeEmbedComponentEditor = exports.YoutubeEmbedComponentCreator = exports.YoutubeEmbedComponentRender = void 0;
const react_1 = __importDefault(require("react"));
const YoutubeEmbed_1 = __importDefault(require("../YoutubeEmbed"));
const react_bootstrap_1 = require("react-bootstrap");
const structure_1 = require("./structure");
function YoutubeEmbedComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const style = component.style;
    return react_1.default.createElement("div", { className: 'border rounded flex-grow-1' },
        react_1.default.createElement("h4", null, "youtube embed"),
        react_1.default.createElement("div", { className: 'd-flex flex-row justify-content-around' },
            react_1.default.createElement("div", { className: 'border rounded' }, component.translated),
            react_1.default.createElement("div", { className: 'border rounded' }, component.original)));
}
exports.YoutubeEmbedComponentRender = YoutubeEmbedComponentRender;
function YoutubeEmbedComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState('');
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "original embedId" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", min: 11, max: 11, style: { height: '100px' }, onChange: (e) => {
                    setoriginal(e.target.value);
                    console.log(e.target.value.length);
                    dispatch((0, structure_1.youtubeEmbedObject)(e.target.value, translated));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "translated embedId" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", min: 11, max: 11, style: { height: '100px' }, onChange: (e) => {
                    settranslated(e.target.value);
                    dispatch((0, structure_1.youtubeEmbedObject)(original, e.target.value));
                } })));
}
exports.YoutubeEmbedComponentCreator = YoutubeEmbedComponentCreator;
function YoutubeEmbedComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState(component.original);
    const [translated, settranslated] = react_1.default.useState(component.translated);
    return (react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement("input", { style: {
                backgroundColor: 'white',
                textAlign: 'center',
                borderWidth: 0,
                width: '100%',
                fontSize: 40,
                fontWeight: 'bold'
            }, min: 11, max: 11, onChange: (e) => {
                setoriginal(e.target.value);
                dispatch((0, structure_1.youtubeEmbedObject)(e.target.value, translated));
            }, value: original }),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", min: 11, max: 11, onChange: (e) => {
                settranslated(e.target.value);
                dispatch((0, structure_1.youtubeEmbedObject)(original, e.target.value));
            }, value: translated !== null && translated !== void 0 ? translated : '', style: { width: 900 } })));
}
exports.YoutubeEmbedComponentEditor = YoutubeEmbedComponentEditor;
function YoutubeEmbedComponentWebsiteRender(props) {
    const component = props.component;
    return react_1.default.createElement(YoutubeEmbed_1.default, { embedId: component.translated });
}
exports.YoutubeEmbedComponentWebsiteRender = YoutubeEmbedComponentWebsiteRender;
